module.exports = __webpack_public_path__ + "static/media/resetSearch-light.0c7fd0f2.svg";